<template>
    <div class="row">
        <div class="col">
            <card>
                <card-header>
                    <card-title>
                        Alternative Angebote
                    </card-title>
                </card-header>
                <card-content>
                    <table class="table table--stripped table--td-top">
                        <thead>
                        <tr>
                            <th>
                                <translate>P.-Nr.</translate>
                            </th>
                            <th>
                                <translate>Stück</translate>
                            </th>
                            <th>
                                <translate>Lieferzeit <span>ab Bestellung</span></translate>
                            </th>
                            <th>
                                <translate>Lieferdatum<span>bei heutiger Bestellung</span></translate>
                            </th>
                            <th>
                                <translate>Stückpreis</translate>
                            </th>
                            <th>
                                <translate>Nettopreis</translate>
                            </th>
                            <th>
                                <translate>Steuer<span>19% Ust.</span></translate>
                            </th>
                            <th>
                                <translate>Gesamtpreis<span>inkl. Versand</span></translate>
                            </th>
                            <th v-if="!hasClientOrder" class="small"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="producerOffer in producerOffers" :key="producerOffer.index">
                            <td>{{ producerOffer.prod_no }}</td>
                            <td v-html="producerOffer.lot_qty"></td>
                            <td v-html="producerOffer.lot_delivery"></td>
                            <td v-html="producerOffer.lot_delivery_dates"></td>
                            <td v-html="producerOffer.price_per_unit"></td>
                            <td v-html="producerOffer.lot_offer"></td>
                            <td v-html="producerOffer.lot_ust"></td>
                            <td v-html="producerOffer.offer_price"></td>
                            <td v-if="!hasClientOrder" class="small">
                                <form-button type="button" dense="true" @click="requestAlternateOfferModal = true; selectedAlternateOffer = producerOffer">
                                    <translate>Anfragen</translate>
                                </form-button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <component-request-alternate-offer-modal :ask-for-quote="askForQuote" :selected-alternate-offer="selectedAlternateOffer"  v-if="requestAlternateOfferModal" @closeDialog="requestAlternateOfferModal = false; selectedAlternateOffer = null;"/>
                </card-content>
            </card>
        </div>
    </div>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardContent from '@partfactory/Shared/Card/CardContent';
import CardTitle from '@partfactory/Shared/Card/CardTitle';
import FormButton from '@partfactory/Shared/Form/FormButton';
import ComponentRequestAlternateOfferModal
    from '@partfactory/Pages/Client/Component/ComponentRequestAlternateOfferModal';

export default {
    name: 'ComponentAlternateOffers',
    components: {ComponentRequestAlternateOfferModal, FormButton, CardTitle, CardContent, CardHeader, Card},
    props: {
        askForQuote: Object,
        hasClientOrder: Boolean,
        clientOfferInvalid: Boolean,
    },
    data() {
        return {
            requestAlternateOfferModal: false,
            selectedAlternateOffer: null,
        };
    },
    computed: {
        clientOfferMargins() {
            let margins = [];
            this.askForQuote.client_offers.map(clientOffer => {
                margins.push(clientOffer.net_price - clientOffer.producer_price);
            });
            return margins;
        },
        producerOffers() {
            let producerOffers = [];

            const bidRoundMembers = this.askForQuote?.bid_round_members?.filter(bid_round_members => {
                return bid_round_members?.offer_given === true && bid_round_members?.producer_user_id !== this.askForQuote?.client_offers?.[0]?.producer_user_id;
            });

            bidRoundMembers.map(producerOffer => {

                producerOffer.prod_no = producerOffer.producer_user.prod_no;

                let lotQty = [];
                lotQty.push(this.askForQuote.lotqty_1, this.askForQuote.lotqty_2, this.askForQuote.lotqty_3, this.askForQuote.lotqty_4);
                producerOffer.lot_qty = lotQty.filter(lot => lot !== null).join('<br>');

                let lotOffer = [];
                lotOffer.push(producerOffer.lot_offer_1, producerOffer.lot_offer_2, producerOffer.lot_offer_3, producerOffer.lot_offer_4);
                lotOffer = lotOffer.map((lot, index) => {
                    if (lot !== null)
                        return lot + this.clientOfferMargins[index];
                });

                producerOffer.lot_offer = lotOffer.map((lot) => {
                    return lot ? (Math.round(lot * 100) / 100).toFixed(2) + ' €' : '';
                }).filter(lot => lot !== '').join('<br>');

                producerOffer.lot_ust = lotOffer.map((lot) => {
                    lot = lot * 0.19;
                    return lot ? (Math.round(lot * 100) / 100).toFixed(2) + ' €' : '';
                }).filter(lot => lot !== '').join('<br>');

                producerOffer.offer_price = lotOffer.map((lot) => {
                    lot = lot * 1.19;
                    return lot ? (Math.round(lot * 100) / 100).toFixed(2) + ' €' : '';
                }).filter(lot => lot !== '').join('<br>');

                let pricePerUnit = [];
                pricePerUnit.push(
                    (lotOffer[0] / this.askForQuote.lotqty_1),
                    (lotOffer[1] / this.askForQuote.lotqty_2),
                    (lotOffer[2] / this.askForQuote.lotqty_3),
                    (lotOffer[3] / this.askForQuote.lotqty_4),
                );
                producerOffer.price_per_unit = pricePerUnit.map(lot => {
                    return lot ? lot.toFixed(2) + ' €' : '';
                }).filter(lot => lot !== '').join('<br>');

                let lotDelivery = [];
                lotDelivery.push(producerOffer.lot_delivery_1, producerOffer.lot_delivery_2, producerOffer.lot_delivery_3, producerOffer.lot_delivery_4);
                producerOffer.lot_delivery = lotDelivery.filter(lot => lot !== null).map(lot => (lot + this.$page.props.factors.delivery_time_part_client) + ' ' + this.$gettext('Tage')).join('<br>');

                producerOffer.lot_delivery_dates = lotDelivery.filter(lot => lot !== null).map(lot => {

                    let delivery_date = '';
                    if (this.$moment().isBusinessDay() && !this.$moment().isHoliday()) {
                        delivery_date = this.$moment().add(lot, 'days');
                    } else {
                        delivery_date = this.$moment().nextBusinessDay().add(lot, 'days');
                    }
                    if (!delivery_date.isBusinessDay() || delivery_date.isHoliday()) {
                        delivery_date = delivery_date.nextBusinessDay();
                    }

                    delivery_date = delivery_date.add(this.$page.props.factors.delivery_time_part_client, 'days');

                    if (!delivery_date.isBusinessDay() || delivery_date.isHoliday()) {
                        delivery_date = delivery_date.nextBusinessDay();
                    }

                    return delivery_date.format('DD.MM.YYYY');
                }).join('<br>');


            });

            producerOffers.push(...bidRoundMembers);

            return producerOffers;
        },
    }
};
</script>
